module.exports = __webpack_public_path__ + "img/Logo_eFC.711409ff.png";